module.exports = __webpack_public_path__ + "static/media/chesmac.8bece084.webm";


//////////////////
// WEBPACK FOOTER
// ./src/Videos/chesmac.webm
// module id = 52
// module chunks = 0